import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { GroupForm } from "../../components/group/GroupForm";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import type { Apprentice } from "../../models/apprentice";
import type { Coach } from "../../models/coach";
import type { YearContext } from "../../models/yearContext";
import { groups_path } from "../../routes";

type GroupCreateProps = {
  apprentice_options?: Apprentice[];
  year_contexts: YearContext[];
  coaches: Coach[];
};

export default function GroupCreate({ apprentice_options, year_contexts, coaches }: GroupCreateProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(groups_path), values);

  return (
    <ContentShell title="Neue Gruppe" onBack={() => router.get(pathWithYearContext(groups_path))}>
      <GroupForm
        apprenticeOptions={apprentice_options}
        yearContexts={year_contexts}
        coaches={coaches}
        submitButtonLabel="Erstellen"
        onSubmit={onSubmit}
      />
    </ContentShell>
  );
}
